module.exports = __webpack_public_path__ + "media/images/riders/KATE_COURTNEY-58c689a783d60503e864e140e0905194.png";